module.exports = __webpack_public_path__ + "static/media/supply_Chain_Infographic.f031b10e.pdf";